import { FC } from 'react';
import { useIntl } from 'react-intl';

import { PageTitle } from '../../../_metronic/layout/core';
import HolidaySheetUploadForm from '../../modules/holidays/components/HolidaySheetUploadForm';

const HolidaySheetPage: FC = () => {
  const intl = useIntl();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'holidaySheet.title' })}
      </PageTitle>
      <div className="row gy-4 mw-700px">
        <div className="card p-10">
          <HolidaySheetUploadForm />
        </div>
      </div>
    </>
  );
};

export { HolidaySheetPage };
